import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const KingsChatSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      alert(`KingsChat Login Failed: ${error}`);
      window.location.href = '/signIn';
      return;
    }

    if (token) {
      // Fetch user profile using the token
      const API_URL = process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || 'https://ceindiazone2.in');
      
      axios.get(`${API_URL}/api/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(res => {
        const user = res.data;
        if (user && user.id) {
          localStorage.setItem('user', JSON.stringify(user));
          
          if (user.role === 'ADMIN') {
            localStorage.setItem('adminUser', JSON.stringify(user));
            window.location.href = '/admin/dashboard';
          } else {
            const redirectUrl = sessionStorage.getItem('loginRedirect') || '/';
            sessionStorage.removeItem('loginRedirect');
            window.location.href = redirectUrl;
          }
        } else {
          throw new Error("Invalid user profile");
        }
      })
      .catch(err => {
        console.error("Failed to fetch user profile:", err);
        alert("Login failed to verify user details.");
        window.location.href = '/signIn';
      });
    } else {
      window.location.href = '/signIn';
    }
  }, [searchParams, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
      <h2>Logging you in via KingsChat...</h2>
      <p>Please wait while we securely complete your sign-in.</p>
    </div>
  );
};

export default KingsChatSuccess;
